var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"15","height":"26","viewBox":"0 0 15 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.6066 0.979185L14.0208 2.3934L3.41424 13L14.0208 23.6066L12.6066 25.0208L2.00002 14.4142L0.585811 13L2.00002 11.5858L12.6066 0.979185Z","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }